module.exports = __webpack_public_path__ + "static/549d62840092f22975dd778b360ff27b.jpg";